import { configureStore } from '@reduxjs/toolkit';
import crateReducer from "../components/redux/crateSlice"

export const store = configureStore({
  reducer: {
    crate:crateReducer,
    
  },
});